module.exports = __webpack_public_path__ + "static/media/xray4Right.db3a329e.jpg";